const demoQrCodeImages = Object.freeze({
    qr_android: 'https://store-acc.soofun.online/static/qr/android.png',
    qr_ios    : 'https://store-acc.soofun.online/static/qr/ios.png'
});

export function getDemoQrCodeImages() {
    return demoQrCodeImages;
}

export default {
    getDemoQrCodeImages
};
